// extracted by mini-css-extract-plugin
export default {"wrapper":"Activities_wrapper__YYn0T","info":"Activities_info__PTOVw"};